<template>
  <div id="app">
    <router-view/>
    <div v-if="!isOnline" class="offline text-white">
      <div class="off text-center container">
        <h3>You are offline!</h3>
        <p>Please check your internet connection.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOnline: true
    }
  },
  mounted() {
    let self = this
    window.addEventListener('online', function () {
      self.isOnline = true
    })
    window.addEventListener('offline', function () {
      self.isOnline = false
    }) 
  },
  methods: {

  }
}
</script>


<style>
#app, .roboto {
  font-family: 'Roboto', sans-serif;
}
h1, h2, h3, h4, h5, h6, .chakra-petch {
  font-family: 'Chakra Petch', sans-serif;
}
.mono {
  font-family: 'Share Tech Mono', monospace;
}

.offline {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.offline:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #000e;
}
.off {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
</style>
